// 표준화된 HEATMAP 차트 옵션 생성
import { formatValue } from '../../../utils/numberFormatter';
import { applyCommonStyles } from './applyCommonStyles';

export const generateHeatmapChartOption = (data, baseOption, options = {}) => {
  // 표준 구조: { categories: { x: [...], y: [...] }, series: [{ name: "...", values: [[x_idx, y_idx, value]] }] }
  const categories = data.categories || {};
  const series = data.series || [];
  
  const xAxisData = categories.x || [];
  const yAxisData = categories.y || [];
  
  if (series.length === 0 || !xAxisData.length || !yAxisData.length) {
    console.error('[Heatmap Chart] Invalid data structure for heatmap:', data);
    return {
      ...baseOption,
      title: { ...baseOption.title, text: '히트맵 데이터 오류' },
      series: [],
    };
  }

  const seriesData = series[0].values || [];

  const option = {
    ...baseOption,
    tooltip: {
      position: 'top',
      formatter: (params) => {
        if (params.value && params.value.length === 3) {
          const xName = xAxisData[params.value[0]];
          const yName = yAxisData[params.value[1]];
          const val = formatValue(params.value[2]);
          return `${yName}<br/>${xName}: ${val}`;
        }
        return '';
      }
    },
    grid: {
      ...baseOption.grid,
      left: '10%',
      right: '10%',
      bottom: '25%',  // visualMap(색상 범례)을 위한 하단 여백
      top: '10%',
      containLabel: true  // ECharts가 라벨 크기만큼 추가 확장
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      name: options.axes?.x || '',
      nameLocation: 'center',
      nameGap: 25,
      nameTextStyle: {
        fontSize: 18,
        fontWeight: '600',
        color: '#2c3e50',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      },
      splitArea: {
        show: true
      }
    },
    yAxis: {
      type: 'category',
      data: yAxisData,
      name: options.axes?.y || '',
      nameLocation: 'center',
      nameGap: 35,
      nameTextStyle: {
        fontSize: 18,
        fontWeight: '600',
        color: '#2c3e50',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      },
      splitArea: {
        show: true
      }
    },
    visualMap: {
      min: options.advanced?.min !== undefined ? options.advanced.min : Math.min(...seriesData.map(item => item[2])),
      max: options.advanced?.max !== undefined ? options.advanced.max : Math.max(...seriesData.map(item => item[2])),
      calculable: true,
      orient: 'horizontal',
      left: 'center',
      bottom: '5%',
      inRange: {
        color: options.style?.colors || ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
      },
      textStyle: {
        fontSize: 10
      }
    },
    series: [{
      name: baseOption.title?.text || 'Heatmap',
      type: 'heatmap',
      data: seriesData,
      label: {
        show: options.advanced?.showDataLabels === true || (options.advanced?.showValueLabels !== undefined ? options.advanced.showValueLabels : true),
        formatter: (params) => {
          if (params.value && params.value.length === 3 && Number.isFinite(params.value[2])) {
            const labelFormat = options.advanced?.labelFormat || '{value}';
            const unitText = options.unit || '';
            const formatted = formatValue(params.value[2]);
            return labelFormat
              .replace('{name}', `${yAxisData[params.value[1]] ?? ''}`)
              .replace('{seriesName}', option.series?.[0]?.name ?? '')
              .replace('{value}', formatted)
              .replace('{unit}', unitText);
          }
          return '';
        },
        fontSize: 10,
        color: '#000'
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }]
  };
  
  // 공통 스타일 적용
  let finalOption = options.style ? applyCommonStyles(option, options.style) : option;

  // transparent 처리 (ECharts 차트 배경 투명도)
  // showFrame은 DashboardComponentRenderer에서 처리하므로 여기서는 transparent만 처리
  if ((options.transparent === true || options.transparent === 'true')) {
    // ECharts 전체 배경과 그리드 배경을 모두 투명하게 설정
    finalOption.backgroundColor = 'transparent';
    if (finalOption.grid) {
      finalOption.grid.backgroundColor = 'transparent';
    }
  }

  return finalOption;
}; 